import React, { useEffect, useRef, useState } from 'react';
import NewAccountModal from '../../../components/NewAccountModal';
import { Icon, UserAvatar } from '../../../components/ui';
import { Link } from '@reach/router';
import { logout } from '../../../lib/auth';

const UserMenu = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [showPopOver, setShowPopOver] = useState(false);
  const [showNewAccountModal, setShowNewAccountModal] = useState(false);

  const handleClickOutside = (event: Event) => {
    const current = wrapperRef.current;
    if (current && wrapperRef.current && !current.contains(event.target as HTMLDivElement)) {
      setShowPopOver(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  return (
    <div className="relative" ref={wrapperRef}>
      <button
        onClick={() => setShowPopOver(true)}
        data-testid="user-menu"
        className="pointer flex items-center ml2"
      >
        <UserAvatar size={24} />
        <div style={{ width: 2 }} />
        <Icon name="caret-left" color="navy" className="rotate-270 mt1" size={14} />
      </button>

      {showPopOver && (
        <div
          className="bg-white shadow-1 absolute top-0 right-0 br2 blue hover-navy tc f6 w4 z-max"
          style={{ top: 40 }}
        >
          <Link
            to="/"
            className="db pointer blue hover-navy w-100 pv2 ph3 bb b--light-gray"
            onClick={() => {
              setShowPopOver(false);
            }}
            data-testid="switch-spaces-button"
          >
            Switch Spaces
          </Link>

          <Link
            to="/notebook/account"
            className="db tl pointer blue hover-navy w-100 pv2 ph3 bb b--light-gray"
            onClick={() => {
              setShowPopOver(false);
            }}
            data-testid="account-button"
          >
            Account
          </Link>

          <button
            className="db pointer blue hover-navy w-100 pv2 ph3"
            onClick={() => {
              logout();
              setShowPopOver(false);
            }}
            data-testid="logout-button"
          >
            Log Out
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
